import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/icon-opensea.svg'
import _imports_1 from '@/assets/images/icon-looksrare.svg'
import _imports_2 from '@/assets/images/icon-rarible.svg'
import _imports_3 from '@/assets/images/icon-foundation.svg'


const _withScopeId = n => (_pushScopeId("data-v-5c8db1e5"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "campaign-platform-links"
}
const _hoisted_2 = ["href"]
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1))
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = ["href"]
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_1 }, null, -1))
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = ["href"]
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_2 }, null, -1))
const _hoisted_10 = [
  _hoisted_9
]
const _hoisted_11 = ["href"]
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1))
const _hoisted_13 = [
  _hoisted_12
]
const _hoisted_14 = ["href"]
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_2 }, null, -1))
const _hoisted_16 = [
  _hoisted_15
]
const _hoisted_17 = ["href"]
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_3,
  style: {"padding":"10px"}
}, null, -1))
const _hoisted_19 = [
  _hoisted_18
]
const _hoisted_20 = ["href"]
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_1 }, null, -1))
const _hoisted_22 = [
  _hoisted_21
]

import { ethers } from 'ethers';
import { computed, onMounted, ref } from 'vue';
import { ClaimType } from '@/api/models/claim';

interface PlatformLinksProps {
  claimConfig: any;
  claim: any;
  label?: string;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'PlatformLinks',
  props: {
    claimConfig: {},
    claim: {},
    label: {}
  },
  setup(__props: any) {

const props = __props;


const openseaCollectionSlug = ref('');
const tokenId1155 = computed(() => {
  if (props?.claim?.tokenId) {
    return ethers.BigNumber.from(props.claim.tokenId).toNumber();
  }
  return null;
});

onMounted(async () => {
  if (!openseaCollectionSlug.value && props.claim && props.claim.total > 0 && props.claim.claimType?.toLowerCase() === ClaimType.ERC721 && props?.claimConfig?.creatorContractAddress) {
    fetch(`https://api.opensea.io/api/v1/asset_contract/${props.claim.creatorContractAddress}`, {
      method: 'GET'
    }).then(response => response.json())
      .then(response => {
        if (response?.collection?.slug) {
          openseaCollectionSlug.value = response?.collection?.slug;
        }
      })
      .catch(err => console.error(err));
  }
});


return (_ctx: any,_cache: any) => {
  return ((_ctx.claimConfig && _ctx.claim && _ctx.claim.total) || (_ctx.claimConfig && _ctx.claimConfig?.claimType == _unref(ClaimType).ERC1155))
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("span", null, _toDisplayString(_ctx.label || 'View on Platforms'), 1),
        (_ctx.claimConfig && _ctx.claimConfig?.claimType && _ctx.claimConfig?.claimType.toLowerCase() == _unref(ClaimType).ERC1155)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createElementVNode("a", {
                target: "_blank",
                href: `https://opensea.io/assets/ethereum/${_ctx.claimConfig?.creatorContractAddress}/${tokenId1155.value}`
              }, _hoisted_4, 8, _hoisted_2),
              _createElementVNode("a", {
                target: "_blank",
                href: `https://looksrare.org/collections/${_ctx.claimConfig?.creatorContractAddress}/${tokenId1155.value}`
              }, _hoisted_7, 8, _hoisted_5),
              _createElementVNode("a", {
                target: "_blank",
                href: `https://rarible.com/token/${_ctx.claimConfig?.creatorContractAddress}:${tokenId1155.value}`
              }, _hoisted_10, 8, _hoisted_8)
            ], 64))
          : (_ctx.claimConfig && _ctx.claim && _ctx.claim.total > 0)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                (openseaCollectionSlug.value)
                  ? (_openBlock(), _createElementBlock("a", {
                      key: 0,
                      target: "_blank",
                      href: `https://opensea.io/collection/${openseaCollectionSlug.value}`
                    }, _hoisted_13, 8, _hoisted_11))
                  : (_openBlock(), _createElementBlock("a", {
                      key: 1,
                      target: "_blank",
                      href: `https://rarible.com/collection/${_ctx.claimConfig?.creatorContractAddress}`
                    }, _hoisted_16, 8, _hoisted_14)),
                _createElementVNode("a", {
                  target: "_blank",
                  href: `https://foundation.app/collection/${_ctx.claimConfig?.creatorContractAddress}`
                }, _hoisted_19, 8, _hoisted_17),
                _createElementVNode("a", {
                  target: "_blank",
                  href: `https://looksrare.org/collections/${_ctx.claimConfig?.creatorContractAddress}`
                }, _hoisted_22, 8, _hoisted_20)
              ], 64))
            : _createCommentVNode("", true)
      ]))
    : _createCommentVNode("", true)
}
}

})